/**
 * Cadre commun : en-tête, menu adapté au profil, zone de contenu.
 *
 * Le menu vient de `navigation.ts` filtré par le profil connecté. Rien n'y est décidé au vol : ce qui
 * est visible pour qui est déclaré en un seul endroit, et vérifié contre le contrat d'API.
 */
import { NavLink, Outlet } from "react-router-dom";

import { useAuth } from "../shared/auth/contexte";
import { menuPour } from "./navigation";

const LIBELLE_PROFIL: Record<string, string> = {
  "admin-totalenergies": "Administrateur TotalEnergies",
  "operationnel-totalenergies": "Opérationnel TotalEnergies",
  "air-tahiti": "Air Tahiti",
  support: "Support technique",
};

export function MiseEnPage() {
  const { identite, seDeconnecter } = useAuth();
  if (!identite) return null;

  return (
    <div className="cadre">
      <header className="cadre__entete">
        <span className="cadre__titre">Suivi des GRV JET A-1</span>
        <div className="cadre__compte">
          <span>{identite.email}</span>
          <small>{LIBELLE_PROFIL[identite.profil] ?? identite.profil}</small>
          <button type="button" onClick={seDeconnecter}>
            Se déconnecter
          </button>
        </div>
      </header>

      <nav className="cadre__menu" aria-label="Navigation principale">
        {menuPour(identite.profil).map((entree) => (
          <NavLink key={entree.chemin} to={entree.chemin} end={entree.chemin === "/"}>
            {entree.libelle}
          </NavLink>
        ))}
      </nav>

      <main className="cadre__contenu">
        <Outlet />
      </main>
    </div>
  );
}
